import { useDispatch, useSelector } from "react-redux";
import { PROFILE_UPDATE_FAILED, PROFILE_UPDATE_SUCCESSFUL, updateProfileInfo } from "../../Actions/passwordUpdateAction";
import { useEffect, useRef, useState } from "react";

const ProfileUpdateModal = ({
  fieldName,
  displayName,
  oldValue,
  setLoading,
}) => {
  const dispatch = useDispatch();
  const infoRef = useRef(null);
  const [success, setSuccess] = useState(null);
  const partnerProfileUpdateState = useSelector(state => state.partnerProfileInfoUpdateState);

  useEffect(() => {
      if (partnerProfileUpdateState === PROFILE_UPDATE_SUCCESSFUL) {
          setLoading(false);
          setSuccess(true);
      } else if (partnerProfileUpdateState === PROFILE_UPDATE_FAILED) {
          setLoading(false);
          setSuccess(false);
      }
  }, [partnerProfileUpdateState]);

  useEffect(() => {
    infoRef.current.value = oldValue;
  }, [fieldName])

  useEffect(() => {
    if (success !== null) {
      const timer = setTimeout(() => {
        if (success) {
          const modal = document.getElementById("profileUpdateModal");
          if (modal) {
              const modalInstance = window.bootstrap.Modal.getInstance(modal);
              if (modalInstance) {
                  modalInstance.hide();
              }
          }
        }
        setSuccess(null);
      }, 2000);
      return () => {
        clearTimeout(timer);
        setSuccess(null);
      }
    }
  }, [success]);

  const handleUpdate = () => {
    setLoading(true); 
    let data = {
      [fieldName]: infoRef.current.value
    }
    dispatch(updateProfileInfo(data));
  }

  return (
    <div
      className="modal fade"
      id="profileUpdateModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="profileUpdateModal"
      aria-hidden={true}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="modalLabel">
              Change {displayName}
            </h5>
          </div>
          <div className="modal-body form-group">
            <label htmlFor="oldInfo" className="form-label mt-4">
              Current {displayName}
            </label>
            <input
              type="text"
              id="oldInfo"
              name="oldInfo"
              className="form-control"
              value={oldValue}
              disabled
            />
            <label htmlFor="newInfo" className="form-label mt-3">
              New {displayName}
            </label>
            <input
              type="text"
              id="newInfo"
              name="newInfo"
              className="form-control"
              ref={infoRef}
            />
          </div>
          {success !== null && <div className={"alert text-center mt-3 " + (success ? "alert-success" : "alert-danger")} role="alert">
            {success ? `${displayName} Updated.` : `${displayName} Update Failed!`}
          </div>}
          <div className={`d-flex justify-content-end ${success !== null ? "mt-2" : "mt-4"}`}>
            <div
              data-bs-dismiss="modal"
              aria-label="Close"
              className="sd-secondary-btn px-4 me-2"
            >
              Cancel
            </div>
            <div className="sd-primary-btn px-4" onClick={handleUpdate}>Update</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProfileUpdateModal;
